import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const AboutPreview = () => {
  return (
    <section className="section about-preview">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">Hakkımızda</h2>
            <p className="section-subtitle">
              LYSEP CORPORATION olarak, teknoloji dünyasında öncü çözümler sunarak 
              işletmelerin dijital dönüşüm yolculuğunda güvenilir partneri oluyoruz.
            </p>
          </div>
          
          <div className="about-features">
            <div className="feature-item">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                </svg>
              </div>
              <div className="feature-content">
                <h3>İnovasyon</h3>
                <p>En son teknolojileri kullanarak yenilikçi çözümler geliştiriyoruz.</p>
              </div>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 12l2 2 4-4"/>
                  <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                  <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"/>
                  <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"/>
                  <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"/>
                </svg>
              </div>
              <div className="feature-content">
                <h3>Kalite</h3>
                <p>Yüksek kalite standartlarında hizmet sunarak müşteri memnuniyetini ön planda tutuyoruz.</p>
              </div>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  <path d="M9 12l2 2 4-4"/>
                </svg>
              </div>
              <div className="feature-content">
                <h3>Güvenlik</h3>
                <p>Veri güvenliği ve gizlilik konularında en yüksek standartları uygulayarak güvenilir çözümler sunuyoruz.</p>
              </div>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <div className="feature-content">
                <h3>Müşteri Odaklılık</h3>
                <p>Müşterilerimizin ihtiyaçlarını anlayarak onlara özel çözümler geliştiriyor ve sürekli destek sağlıyoruz.</p>
              </div>
            </div>
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <Link to="/about" className="btn">Daha Fazla Bilgi</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;

